import { render } from "./accommodations.vue?vue&type=template&id=15d722ae&scoped=true"
import script from "./accommodations.vue?vue&type=script&lang=js"
export * from "./accommodations.vue?vue&type=script&lang=js"

import "./accommodations.vue?vue&type=style&index=0&id=15d722ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d722ae"]])

export default __exports__